import { useIntl } from 'react-intl'
import * as Sentry from '@sentry/browser'
import { useSelector } from 'react-redux'
import { useState, useEffect } from 'react'
import ChartHoverSelector from './ChartHoverSelector/ChartHoverSelector'
import TemperatureLineChart from '../../../../charts/temperature-line-chart'
import { selectCurrentMarketIndexHistoryByMonth } from '../../../../store/selectors/marketRecord'

import styles from './MarketSpotlightChart.module.scss'

export interface MarketSpotlightChartProps {
  className?: string
  placementId: string
  withXAxis?: boolean
}

export const MarketSpotlightChart = ({ className, placementId, withXAxis = true }: MarketSpotlightChartProps) => {
  const intl = useIntl()
  const data = useSelector(selectCurrentMarketIndexHistoryByMonth)
  const [index, setIndex] = useState(data?.length ? data.length - 1 : -1)

  const transformedValueLineChartValuations =
    data &&
    Object.values(data).map((val, i) => ({
      id: `Temp_Index_${i}`,
      date: new Date(`${val.month}-02`),
      valuation: val.value
    }))

  useEffect(() => {
    let chart: TemperatureLineChart

    if (data?.length && data.length >= 3) {
      chart = new TemperatureLineChart(
        document.getElementById(placementId),
        {
          intl
        },
        withXAxis
      )

      try {
        chart.update({
          segments: [
            {
              count: transformedValueLineChartValuations?.length,
              valuations: transformedValueLineChartValuations
            }
          ]
        })
      } catch (e) {
        Sentry.captureMessage('Error updating MarketSpotlightChart.tsx chart with data: ', {
          extra: { rawData: data, transformedData: transformedValueLineChartValuations }
        })
      }
    }

    return () => chart?.destroy()
  }, [intl, transformedValueLineChartValuations, data])

  if (!data?.length || data.length < 3) return null

  return (
    <div className={className}>
      <div className={styles.container}>
        <svg className={styles.chart} id={placementId} data-qa={placementId} />
        <ChartHoverSelector index={index} data={data} setIndex={setIndex} />
      </div>
    </div>
  )
}
